import classNames from 'classnames'
import { type StructuredText as StructuredTextType } from 'datocms-structured-text-utils'
import { graphql } from 'gatsby'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import StructuredTextDefault from '@/components/structured-text/structured-text-default'

import Image from '../../image/image'
import Cta from '../cta/cta'
import * as styles from './styles.module.scss'

const FeatureSection: React.FC<Queries.FeatureSectionFragment> = ({
  title,
  subtitle,
  items
}) => {
  return (
    <div className={styles.featureSection}>
      <Container className="">
        <Row className="mb-3 mt-2">
          <Col>
            <h2>{title}</h2>
            <h3>{subtitle}</h3>
          </Col>
        </Row>
        <Row className="gx-lg-5 mb-3">
          {items?.map((item, index) => {
            if (item === null) return null
            const { isFeatured, content, icon, id, moreInfo, subtitle, title } =
              item
            const styleFeatured =
              isFeatured !== null && isFeatured ? styles.featured : ''
            const classMarginColumn =
              index === 1 || index === 3 ? styles.marginTopSpecial : ''
            const cta = moreInfo !== null ? moreInfo[0] : null
            return (
              <Col
                key={id}
                xl={6}
                className={classNames(styles.column, classMarginColumn)}
              >
                <Row className={styleFeatured}>
                  <Col
                    xl={5}
                    lg={6}
                    className={classNames(styles.bgColor, 'pt-4 pb-5')}
                  >
                    <div className="ps-2 pb-4 pe-4">
                      <h4>{title}</h4>
                      <p>{subtitle}</p>
                    </div>

                    <Image image={icon} />
                  </Col>
                  <Col className={`pt-3 pt-md-5 ${styles.columnText}`}>
                    <StructuredTextDefault
                      content={content as unknown as StructuredTextType}
                    />
                    {cta !== null && (
                      <div className="text-center mt-2 mt-lg-0">
                        <Cta {...cta} className={styles.fixedButton} />
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            )
          })}
        </Row>
      </Container>
    </div>
  )
}

export default FeatureSection

export const query = graphql`
  fragment FeatureSection on DatoCmsFeatureSection {
    __typename
    id
    navigationLabel
    title
    subtitle
    items {
      id
      title
      subtitle
      icon {
        gatsbyImageData
        url
      }
      content {
        value
      }
      moreInfo {
        ... on DatoCmsCta {
          __typename
          ...Cta
        }
      }
      isFeatured
    }
  }
`
